module.exports = __webpack_public_path__ + "img/Bundesliga_1_Whitelabel_400x416.8f924988.jpg";